<template>
  <div class="batch batch-show">
    <Tem>
      <template slot="close">
        <el-button type="text"
                   icon="el-icon-close"
                   @click="closeDialog"></el-button>
      </template>
      <template slot="title">{{$t('model.EditTasks')}}({{ids.length}})</template>
      <template slot="form">
        <el-form label-position="top"
                 size="mini">
          <el-form-item :label="$t('model.Status')">
            <el-select v-model="form.Status"
                       clearable
                       size="mini">
              <el-option v-for=" i of taskStatus"
                         :key="i.Value"
                         :label="$t('api.'+i.Key)"
                         :value="i.Value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('model.%Done')">
            <el-select v-model="form.CompletionRate"
                       size="mini"
                       filterable
                       allow-create
                       default-first-option
                       clearable
                       @blur.native.capture="setManualCompletionRate"
                       @change="changeRate"
                       :disabled="form.TaskType === 4">
              <el-option v-for="p of tasksProgressOptions"
                         :key="p.Key"
                         :label="p.Value"
                         :value="p.Key"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('model.TaskGroup')">
            <el-select v-model="form.TaskPhaseId"
                       clearable
                       size="mini">
              <el-option v-for="i of taskGroup"
                         :key="i.PhaseId"
                         :label="i.Name"
                         :value="i.PhaseId"></el-option>
            </el-select>
            <el-button circle
                       type="primary"
                       size="mini"
                       v-has="'Create Task Group'"
                       :title="$t('groupDialog.AddTaskGroup')"
                       style="position: absolute;top: -120%;right:0"
                       @click="openGroupDialog"><i class="el-icon-plus"></i></el-button>
          </el-form-item>
          <el-form-item :label="$t('model.StartDate')">
            <el-date-picker v-model="form.StartDate"
                            size="mini"
                            :placeholder="$t('model.Select')">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('model.DueDate')">
            <el-date-picker v-model="form.EndDate"
                            size="mini"
                            :placeholder="$t('model.Select')">
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('model.Assignee')"
                        v-if="jobsiteID">
            <el-select v-model="assign"
                       @change="changeAssign"
                       size="mini"
                       clearable
                       :placeholder="$t('model.SelectAssignee')">
              <el-option v-for="item in projectUser"
                         :key="item.UserId"
                         :label="item.FullName"
                         :value="item.UserId">
                <div class="user-logo">
                  <img :src="item.AvatarUrl"
                       alt="">
                </div>
                <span style="margin-left:40px;">{{ item.FullName }}({{ item.LoginAccount }})</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('model.Watching')"
                        v-if="jobsiteID">
            <el-select v-model="form.WatchingUserIds"
                       size="mini"
                       multiple
                       clearable
                       :placeholder="$t('model.SelectWatching')">
              <el-option v-for="item in projectUser"
                         :key="item.UserId"
                         :label="item.FullName"
                         :value="item.UserId">
                <div class="user-logo">
                  <img :src="item.AvatarUrl"
                       alt="">
                </div>
                <span style="margin-left:40px;">{{ item.FullName }}({{ item.LoginAccount }})</span>
              </el-option>
            </el-select>
          </el-form-item>
          <el-divider></el-divider>
          <el-button size="mini"
                     type="primary"
                     style="width:100%"
                     :disabled="disableSave"
                     @click="batchMarkAsDown()">{{$t('taskDialog.MarkAsDone')}}</el-button>
        </el-form>
      </template>
      <template slot="footer">
        <el-row>
          <el-col :span="12">
            <el-button size="mini"
                       type="danger"
                       v-has="'Delete Task'"
                       :disabled="disableSave"
                       @click="batchDelete()">{{$t('taskDialog.Delete')}}</el-button>
          </el-col>
          <el-col :span="12">
            <el-button size="mini"
                       type="primary"
                       :disabled="disableSave"
                       @click="save()">{{$t('taskDialog.Save')}}</el-button>
          </el-col>
        </el-row>
      </template>
    </Tem>
    <Group-Dialog :showDialog="groupDialog.showDialog"
                  @closeDialog="closeGroupDialog"></Group-Dialog>
  </div>
</template>

<script>
import Tem from './layout/taskTemplate'
import GroupDialog from '@components/group/groupDialog'
import { mapState } from 'vuex'
import { BatchMainTasks, deleteTask } from '@/api/config'
export default {
  data () {
    return {
      assign: null,
      user: [],
      disableSave: false,
      groupDialog: {
        showDialog: false
      },
      form: {
        TaskIds: [],
        Status: null,
        TaskPhaseId: null,
        EndDate: null,
        WatchingUserIds: [],
        AssignedUserIds: [],
        CompletionRate: null,
        StartDate: null
      },
      loading: false,
      progressOptions: []
    }
  },
  computed: {
    ...mapState(['jobsiteID', 'mockUserInfo', 'taskStatus', 'taskGroup', 'projectUser']),
    ids () {
      return this.$store.state.diag.data.batchTaskIds
    },
    tasksProgressOptions () {
      return this.$store.state.diag.data.tasksProgressOptions
    }
  },
  async created () {
    if (this.$route.params.type) {
      let task = await this.getTaskById(this.ids[0])
      for (let i in task) {
        for (let j in this.form) {
          if (i === j) {
            this.form[i] = task[i]
          }
        }
      }
      this.assign = task.AssignedUserIds[0]
      this.form.WatchingUserIds = task.WatchingUserIds
    }
  },
  mounted () {
    if (this.ids.length === 0) {
      this.closeDialog()
    }
    this.progressOptions = this.tasksProgressOptions
    if (this.mockUserInfo && this.mockUserInfo.UserId) {
      this.disableSave = true
    }
  },
  watch: {
    tasksProgressOptions (to, from) {
      this.progressOptions = to
    }
  },
  methods: {
    setManualCompletionRate (e) {
      let value = e.target.value
      if (value) {
        this.changeRate(value)
      }
    },
    changeAssign () {
      this.form.AssignedUserIds = []
      this.form.AssignedUserIds.push(this.assign)
    },
    closeGroupDialog (id) {
      if (id) {
        this.$store.dispatch('getTaskGroup').then(() => {
          this.$nextTick(() => {
            this.form.TaskPhaseId = id
          })
        })
      }
      this.groupDialog.showDialog = false
    },
    openGroupDialog () {
      this.groupDialog.showDialog = true
    },
    closeDialog (needRefresh) {
      this.$emit('closeDialog', needRefresh)
    },
    async save () {
      const loading = this.$loading({
        lock: true,
        text: this.$t('taskDialog.Saving'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      this.form.TaskIds = this.ids
      if (this.form.CompletionRate) {
        this.form.CompletionRate = parseFloat(this.form.CompletionRate)
      }
      BatchMainTasks(this.form).then(res => {
        loading.close()
        this.closeDialog(true)
      }).catch(res => { loading.close() })
    },
    changeRate (rate) {
      if (rate === '') {
        this.form.CompletionDate = null
        return
      }
      let formateRate = rate.replace ? this.$config.getFormatNumber(rate.replace(/[^\d.]/g, '')) : this.$config.getFormatNumber(rate)
      if ((isNaN(formateRate) || formateRate <= 0)) {
        formateRate = 0
      } else if (formateRate > 100) {
        formateRate = 100
      }
      this.form.CompletionRate = formateRate
      if (!this.tasksProgressOptions.find(q => q.Key === this.form.CompletionRate)) {
        this.form.CompletionRate = this.form.CompletionRate + '%'
      }
      if (formateRate === 100) {
        this.form.Status = 'Completed'
        this.form.CompletionDate = this.$config.UTCTime(null, true)
      } else if (formateRate < 100) {
        this.form.CompletionDate = null
      }
    },
    batchDelete () {
      this.$confirm(this.$t('model.AreYouSureYouWantToDeleteTheseTasks'), this.$t('model.TIPS'), {
        confirmButtonText: this.$t('model.Yes'),
        cancelButtonText: this.$t('model.No'),
        closeOnClickModal: false,
        closeOnPressEscape: false,
        type: 'warning'
      }).then(() => {
        const loading = this.$loading({
          lock: true,
          text: this.$t('taskDialog.Saving'),
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        })
        deleteTask(this.ids).then(res => {
          loading.close()
          this.closeDialog(true)
        })
      }).catch(() => {
      })
    },
    async batchMarkAsDown () {
      this.form.CompletionDate = this.$config.UTCTime(null, true)
      this.form.CompletionRate = 100
      this.form.Status = 'Completed'
      this.save()
    }
  },
  components: {
    Tem,
    GroupDialog
  }
}
</script>

<style scoped lang='scss'>
.batch {
  position: relative;
  height: 100%;
  width: 100%;
  .footer {
    .el-row {
      width: 100%;
      .el-button {
        width: 98%;
      }
    }
  }
}
.batch-show {
  right: 0;
}
.user-logo {
  width: 30px;
  height: 30px;
  overflow: hidden;
  border-radius: 50%;
  position: absolute;
  left: 20px;
  top: 50%;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  img {
    width: 30px;
    height: 30px;
  }
}
</style>
